import type { DashboardMetric } from '../../../types/dashboard';
import { CHART_GOAL_LINE_COLOR, MAX_QUARTERS_CHART } from '../constants';
import { asNumber } from '../metricSeriesUtils';

const SERIES_META_KEYS = new Set(['quarter', 'goal', 'goalStatus']);

/** @deprecated Use CHART_GOAL_LINE_COLOR from ../constants */
export const METRIC_GOAL_LINE_STROKE = CHART_GOAL_LINE_COLOR;

export type { MetricGoalEval } from '../chartGoalUtils';
export {
  aggregateQuarterlyChartToAnnual,
  attachGoalValuesToChartData,
  attachMappedGoalTargets,
  collectGoalValues,
  getGoalKeysWithValues,
  getGoalTargetsFromPoint,
  readPointFieldGoal,
} from '../chartGoalUtils';
export { asNumber, calcYtdYoYChange, formatYoYSublabel, latest, parseQuarter, pctChange, previous } from '../metricSeriesUtils';
export {
  buildChartYDomain,
  buildCountYAxisScale,
  buildCountYAxisScaleForChart,
} from '../chartUtils';

export function humanizeFieldName(field: string): string {
  return field
    .split(/[._]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatMetricTitle(metricId: string, valueKeys: string[]): string {
  if (valueKeys.length === 1) {
    return humanizeFieldName(valueKeys[0]);
  }
  const suffix = metricId.includes('.') ? metricId.split('.').pop() ?? metricId : metricId;
  return humanizeFieldName(suffix);
}

export function extractValueKeys(series: Record<string, unknown>[]): string[] {
  const keys = new Set<string>();
  for (const point of series) {
    for (const [key, value] of Object.entries(point)) {
      if (!SERIES_META_KEYS.has(key) && typeof value === 'number' && Number.isFinite(value)) {
        keys.add(key);
      }
    }
  }
  return Array.from(keys).sort();
}

export function getMetricSeries(metric: DashboardMetric): Record<string, unknown>[] {
  return metric.series.slice(-MAX_QUARTERS_CHART);
}

export function getPointValue(point: Record<string, unknown>, valueKeys: string[]): number {
  if (valueKeys.length === 1) {
    return asNumber(point[valueKeys[0]]);
  }
  return valueKeys.reduce((sum, key) => sum + asNumber(point[key]), 0);
}

export function getAllTimeValue(
  allTime: Record<string, unknown> | null | undefined,
  valueKeys: string[]
): number {
  if (!allTime) return 0;
  if (valueKeys.length === 1) {
    return asNumber(allTime[valueKeys[0]]);
  }
  return valueKeys.reduce((sum, key) => sum + asNumber(allTime[key]), 0);
}
